USE_STATE_ARRAY = [{key: '0', value: '禁用'}, {key: '1', value: '正常'}]
DELETE_STATE_ARRAY = [{key: '0', value: '正常'}, {key: '1', value: '已删除'}]
// BUSINESS_SIZE_ARRAY = [{key: '0', value: '小'},{key: '1', value: '中'},{key: '2', value: '大'}]
// USER_SEX_TYPE_ARRAY = [{key: '0', value: '男'},{key: '1', value: '女'}]
BOOLEAN_ARRAY = [{key: '0', value: '否'},{key: '1', value: '是'}]
// ROLE_EDIT_TYPE_ARRAY = [{key: '0', value: '不可编辑'},{key: '1', value: '可编辑'}]
TREE_LEVEL_ARRAY = [{key: '1', value: '根级'},{key: '2', value: '二级'},{key: '3', value: '三级'}]
ROLE_ARRAY = [{key: '0', value: '固定角色'},{key: '1', value: '可编辑'}]
FX_MEMBER_TYPE_ARRAY = [
  { key: 1, value: '管理员' },
  { key: 2, value: '一级分销商' },
  { key: 3, value: '二级分销商' },
  { key: 4, value: '普通用户' },
  { key: 5, value: '送货员' }
]
FX_GENDER_ARRAY = [
  { key: 0, value: '未知' },
  { key: 1, value: '男' },
  { key: 2, value: '女' }
]
FX_REGISTER_SOURCE_ARRAY = [
  { key: 'qrcode', value: '扫码' },
  { key: 'link', value: '链接' },
  { key: 'organic', value: '自然注册' },
  { key: 'admin', value: '后台录入' }
]
FX_BIND_SOURCE_ARRAY = [
  { key: 'qrcode', value: '扫码' },
  { key: 'link', value: '链接' },
  { key: 'share', value: '分享' },
  { key: 'manual', value: '后台手动' }
]
FX_DISTRIBUTOR_LEVEL_ARRAY = [
  { key: 1, value: '一级' },
  { key: 2, value: '二级' }
]
FX_BIND_ACTIVE_ARRAY = [
  { key: '1', value: '有效' },
  { key: '0', value: '无效' }
]
FX_ARTICLE_CONTENT_TYPE_ARRAY = [
  { key: 1, value: '短视频' },
  { key: 2, value: '图文' }
]
FX_ARTICLE_PUBLISH_STATUS_ARRAY = [
  { key: 0, value: '草稿' },
  { key: 1, value: '已发布' },
  { key: 2, value: '已下架' }
]
FX_MEDIA_TYPE_ARRAY = [
  { key: 'video', value: '视频' },
  { key: 'image', value: '图片' }
]
FX_PRODUCT_PUBLISH_STATUS_ARRAY = [
  { key: 0, value: '下架' },
  { key: 1, value: '上架' }
]
FX_COMMISSION_TRIGGER_ARRAY = [
  { key: 'direct_l1_sale', value: '一级直接销售' },
  { key: 'l2_sale', value: '二级销售' }
]
FX_COMMISSION_ROLE_DIRECT_L1_ARRAY = [
  { key: 'seller_l1', value: '一级销售分销商' },
  { key: 'platform', value: '平台' }
]
FX_COMMISSION_ROLE_L2_ARRAY = [
  { key: 'seller_l2', value: '二级销售分销商' },
  { key: 'parent_l1', value: '上级一级分销商' },
  { key: 'platform', value: '平台' }
]
FX_COMMISSION_CALC_TYPE_ARRAY = [
  { key: 'percent', value: '按比例(%)' },
  { key: 'fixed', value: '固定金额(元)' }
]
FX_WALLET_CHANGE_TYPE_ARRAY = [
  { key: 'commission_in', value: '分红入账' },
  { key: 'freeze', value: '提现冻结' },
  { key: 'unfreeze', value: '提现解冻' },
  { key: 'withdraw_success', value: '提现成功' },
  { key: 'withdraw_fail', value: '提现失败退回' },
  { key: 'adjust', value: '后台调账' }
]
FX_WALLET_BIZ_TYPE_ARRAY = [
  { key: 'settlement', value: '分红结算' },
  { key: 'withdraw', value: '提现' },
  { key: 'admin', value: '后台操作' }
]
FX_SETTLEMENT_STATUS_ARRAY = [
  { key: 0, value: '处理中' },
  { key: 1, value: '已入账' },
  { key: 2, value: '失败' }
]
FX_WITHDRAW_STATUS_ARRAY = [
  { key: 0, value: '待审核' },
  { key: 1, value: '审核通过' },
  { key: 2, value: '审核拒绝' },
  { key: 3, value: '转账中' },
  { key: 4, value: '转账成功' },
  { key: 5, value: '转账失败' },
  { key: 6, value: '已撤销' }
]
FX_ORDER_STATUS_ARRAY = [
  { key: 0, value: '待支付' },
  { key: 1, value: '已支付' },
  { key: 2, value: '已发货' },
  { key: 3, value: '已完成' },
  { key: 4, value: '已取消' },
  { key: 5, value: '退款中' },
  { key: 6, value: '已退款' }
]
FX_ORDER_PAY_STATUS_ARRAY = [
  { key: 0, value: '未支付' },
  { key: 1, value: '已支付' },
  { key: 2, value: '部分退款' },
  { key: 3, value: '全额退款' }
]
FX_ORDER_SOURCE_ARRAY = [
  { key: 1, value: '购物车' },
  { key: 2, value: '立即购买' },
  { key: 3, value: '资讯直购' }
]
FX_ORDER_STOCK_STATUS_ARRAY = [
  { key: 0, value: '未预占' },
  { key: 1, value: '已预占' },
  { key: 2, value: '已扣减' },
  { key: 3, value: '已释放' }
]
FX_STOCK_LOCK_STATUS_ARRAY = [
  { key: 1, value: '预占中' },
  { key: 2, value: '已扣减' },
  { key: 3, value: '已释放' },
  { key: 4, value: '已取消' }
]
FX_STOCK_LOCK_SOURCE_ARRAY = [
  { key: 'cart', value: '购物车结算' },
  { key: 'buy_now', value: '立即购买' },
  { key: 'article', value: '资讯直购' }
]
FX_STOCK_CHANGE_TYPE_ARRAY = [
  { key: 'in', value: '入库' },
  { key: 'out', value: '出库' },
  { key: 'lock', value: '预占' },
  { key: 'unlock', value: '释放预占' },
  { key: 'deduct', value: '扣减' },
  { key: 'refund', value: '退款回库' },
  { key: 'adjust', value: '手工调整' }
]
FX_STOCK_BIZ_TYPE_ARRAY = [
  { key: 'order', value: '订单' },
  { key: 'payment', value: '支付' },
  { key: 'refund', value: '退款' },
  { key: 'admin', value: '后台' },
  { key: 'cron', value: '定时任务' }
]
FX_SKU_TYPE_ARRAY = [
  { key: 0, value: '现货' },
  { key: 1, value: '履约' }
]
FX_GIFT_VOUCHER_SHELF_STATUS_ARRAY = [
  { key: 1, value: '上架' },
  { key: 0, value: '下架' }
]
FX_BENEFIT_DELIVERY_STATUS_ARRAY = [
  { key: 0, value: '待发货' },
  { key: 1, value: '发货中' },
  { key: 2, value: '已完成' },
  { key: 3, value: '失败' }
]
FX_PAYMENT_STATUS_ARRAY = [
  { key: 0, value: '待支付' },
  { key: 1, value: '成功' },
  { key: 2, value: '失败' },
  { key: 3, value: '已关闭' },
  { key: 4, value: '已退款' }
]
FX_REFUND_STATUS_ARRAY = [
  { key: 0, value: '申请中' },
  { key: 1, value: '退款中' },
  { key: 2, value: '成功' },
  { key: 3, value: '失败' },
  { key: 4, value: '已拒绝' }
]
FX_REFUND_TYPE_ARRAY = [
  { key: 1, value: '仅退款' },
  { key: 2, value: '退货退款' }
]
FX_COMMISSION_SETTLE_STATUS_ARRAY = [
  { key: 0, value: '待结算' },
  { key: 1, value: '可提现' },
  { key: 2, value: '已纳入提现' },
  { key: 3, value: '已取消' }
]
FX_LOGISTICS_SHIP_RULE_TYPE_ARRAY = [
  { key: 'within_48h', value: '按下单48小时内发货' },
  { key: 'monthly_once', value: '按固定每月1次' },
  { key: 'weekly_once', value: '按固定每周1次' },
  { key: 'monthly_twice', value: '按固定每月2次' }
]
FX_LOGISTICS_REGION_LEVEL_ARRAY = [
  { key: '1', value: '全省' },
  { key: '2', value: '指定城市' }
]
FX_WEEKDAY_ARRAY = [
  { key: 1, value: '周一' },
  { key: 2, value: '周二' },
  { key: 3, value: '周三' },
  { key: 4, value: '周四' },
  { key: 5, value: '周五' },
  { key: 6, value: '周六' },
  { key: 7, value: '周日' }
]
FX_MONTH_DAY_ARRAY = Array.from({ length: 31 }, (_, i) => ({ key: i + 1, value: `${i + 1}日${i + 1 === 31 ? '(无31日则30日)' : ''}` }))